import { format, addDays } from 'date-fns';
import { SxProps, Theme } from '@mui/material/styles';
import { Inspection, InspectionStatus, PriorityLevel } from '../types';

/**
 * Generate mock inspection data for demo
 */
export const generateMockInspections = (): Inspection[] => {
  const today = new Date();
  const statuses: InspectionStatus[] = ['Scheduled', 'Rescheduled', 'In Progress', 'completed', 'issue', 'cancelled'];
  const types = ['Initial', 'Progress', 'Final', 'Follow-up'];
  const subcodes = ['BUILDING', 'ELECTRICAL', 'FIRE', 'PLUMBING', 'MECHANICAL'];

  // Generate 15 mock inspections
  return Array.from({ length: 15 }, (_, i) => {
    const randomDay = addDays(today, Math.floor(Math.random() * 14) - 7); // -7 to +7 days from today
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    const subcode = subcodes[Math.floor(Math.random() * subcodes.length)];
    const type = types[Math.floor(Math.random() * types.length)];

    let priority: PriorityLevel = 'Normal';
    if (i % 5 === 0) priority = 'High';
    else if (i % 3 === 0) priority = 'Urgent';

    return {
      id: `INSP-2025-${1000 + i}`,
      inspectionId: "123",
      applicationId: `APP-2025-${2000 + i}`,
      applicationNumber: `BLD-2025-${3000 + i}`,
      applicationTitle: `${subcode === 'BUILDING' ? 'Building' : subcode === 'ELECTRICAL' ? 'Electrical' : subcode === 'FIRE' ? 'Fire Safety' : subcode === 'PLUMBING' ? 'Plumbing' : 'HVAC'} ${type} - ${5000 + i} Main St`,
      applicantName: `Applicant ${i + 1}`,
      propertyAddress: `${5000 + i} Main Street, Suite ${100 + i}, New York, NY 10001`,
      inspectionDate: format(randomDay, 'yyyy-MM-dd'),
      inspectionNote: "",
      documents: [],
      timeSlot: i % 2 === 0 ? '09:00 AM - 11:00 AM' : i % 3 === 0 ? '11:00 AM - 01:00 PM' : i % 5 === 0 ? '02:00 PM - 04:00 PM' : '04:00 PM - 06:00 PM',
      status,
      priority,
      notes: status === 'issue' ? 'Access to site was restricted. Need to reschedule.' : '',
      subcode,
      inspectionType: `${subcode} ${type}`,
      contactName: `Contact Person ${i + 1}`,
      contactPhone: `(555) ${100 + i}-${2000 + i}`,
      completedAt: status === 'completed' ? format(addDays(randomDay, -1), 'yyyy-MM-dd HH:mm:ss') : null,
      completionNotes: status === 'completed' ? 'Inspection completed successfully. All requirements met.' : null,
      attachments: status === 'completed' ? [
        { id: `att-${i}-1`, name: 'inspection_photo_1.jpg', type: 'image/jpeg' },
        { id: `att-${i}-2`, name: 'compliance_report.pdf', type: 'application/pdf' }
      ] : [],
      inspectionCheckList: []
    };
  });
};

/**
 * Get inspection date indicator styles
 */
export const getDateIndicatorStyle = (inspection: Inspection): SxProps<Theme> => {
  const today = format(new Date(), 'yyyy-MM-dd');
  const tomorrow = format(addDays(new Date(), 1), 'yyyy-MM-dd');

  if (inspection.inspectionDate === today) {
    return { bgcolor: 'error.main', color: 'white', borderRadius: 1, px: 1, py: 0.5 };
  } else if (inspection.inspectionDate === tomorrow) {
    return { bgcolor: 'warning.main', color: 'white', borderRadius: 1, px: 1, py: 0.5 };
  } else if (inspection.status === 'completed') {
    return { bgcolor: 'success.light', color: 'white', borderRadius: 1, px: 1, py: 0.5 };
  } else {
    return { bgcolor: 'action.selected', borderRadius: 1, px: 1, py: 0.5 };
  }
};